import React, { Component } from 'react';

import './MarkItem.css'
export class MarkItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }

    }

    componentDidMount() {
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <div className={(this.props.checked ?? false) ? "markItem active": 'markItem'} onClick={this.handleClick}>
                <div>
                    <img src={this.props.data.icon} alt={this.props.data.name} width={24} height={24}/>
                </div>
                <span>{this.props.data.name}</span>
            </div>
        );
    }

    handleClick = () => {
        this.props.handleClick&&this.props.handleClick(this.props.data);
    }    
}